import React from "react";
import { css } from "aphrodite/no-important";
import { styles } from "src/styles/AuthorPublications";
import { RequestState } from "src/models/RequestState";
import axios from "axios";
import { Api } from "src/core/api";
import { JsonConvert } from "json2typescript";
import { AuthorCombinedTrendChartItem } from "./charts/CombinedTrendChart";
import millify from "millify";
import { URLBuilder } from "src/core/URLBuilder";


interface ICombinedInfoProps {
    author_id: string,
    startYear: number,
    endYear: number
}

class CombinedInfoData {
    public startYear: number = 0;
    public endYear: number = 0;
    public awards_pi: number = 0;
    public awards_total: number = 0;
    public awards_count: number = 0;
    public proposals_pi: number = 0;
    public proposals_total: number = 0;
    public proposals_count: number = 0;
    public expenditures: number = 0;
    public expenditures_count: number = 0;
}

class CombinedInfoState {
    public readonly requestState: RequestState = RequestState.NOT_ASKED;
    public readonly data: CombinedInfoData = new CombinedInfoData();
    public readonly error: string = ""
}

export class CombinedInfo extends React.Component<ICombinedInfoProps,CombinedInfoState> {

    constructor(props: ICombinedInfoProps){
        super(props);
        this.state = new CombinedInfoState();
    }

    public componentDidMount(){
        this.fetchData();           
    }

    public componentDidUpdate(prevProps: ICombinedInfoProps) {
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props)){
            this.fetchData();
        }
    }

    private fetchData = () => {
        this.setState({...this.state,requestState: RequestState.LOADING});

        const url = URLBuilder.author_combined_trend(this.props.author_id, this.props.startYear, this.props.endYear)
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data: AuthorCombinedTrendChartItem[] = jsonConvert.deserialize(res.data, AuthorCombinedTrendChartItem);
                    const dataAggregated = new CombinedInfoData();
                    if(data.length > 1){
                        data.sort((item1: AuthorCombinedTrendChartItem, item2: AuthorCombinedTrendChartItem)=>{return item1.year - item2.year})
                        dataAggregated.startYear = data[0].year;
                        if(data.length > 1){
                            dataAggregated.endYear = data[data.length - 1].year;
                        }else{
                            dataAggregated.endYear = dataAggregated.startYear;
                        }
                    }                    
                    for (const item of data){
                        dataAggregated.awards_pi = dataAggregated.awards_pi+(+item.awards_pi)
                        dataAggregated.awards_total = dataAggregated.awards_total+(+item.awards_total)
                        dataAggregated.awards_count = dataAggregated.awards_count+(+item.awards_count)
                        dataAggregated.proposals_pi = dataAggregated.proposals_pi+(+item.proposals_pi)
                        dataAggregated.proposals_total = dataAggregated.proposals_total+(+item.proposals_total)
                        dataAggregated.proposals_count = dataAggregated.proposals_count+(+item.proposals_count)
                        dataAggregated.expenditures = dataAggregated.expenditures+(+item.expenditures)
                    }
                    const newState = {...this.state, requestState: RequestState.SUCCESS, data: dataAggregated}
                    this.setState(newState)
                }catch(error) {
                    const newState = {...this.state, requestState: RequestState.ERROR, error: error.toString()}
                    this.setState(newState)
                }
            }else{
                const error = res.statusText + ":" + res.data
                const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                this.setState(newState)
            }    
        }).catch((err)=>{
            const error = err.toString();
            const newState = {...this.state, requestState: RequestState.ERROR, error: error}
            this.setState(newState)
        });   
    }

    public render() {

        let content;


        if(this.state.requestState === RequestState.SUCCESS){
            content = (
                <React.Fragment>
                    <div id="h-score-section" className={css(styles.info_section)} >

                        <div id="label" className={css(styles.info_section_label)} >
                            {`Proposals from ${this.state.data.startYear} to ${this.state.data.endYear}`}
                        </div>

                        <div id="value" className={css(styles.info_section_value)} >
                            {"$" + millify(+this.state.data.proposals_pi)} / {"$" + millify(+this.state.data.proposals_total)} over {this.state.data.proposals_count} Proposals 
                        </div>

                        </div>

                        <div id="seperator" className={css(styles.seperator)} />

                        <div id="documents-section" className={css(styles.info_section)} >

                        <div id="label" className={css(styles.info_section_label)} >
                            {`Awards from ${this.state.data.startYear} to ${this.state.data.endYear}`}
                        </div>

                        <div id="value" className={css(styles.info_section_value)} >
                            {"$" + millify(+this.state.data.awards_pi)} / {"$" + millify(+this.state.data.awards_total)} over {this.state.data.awards_count} Awards 
                        </div>  

                        </div>

                        <div id="seperator" className={css(styles.seperator)} />

                        <div id="citations-section" className={css(styles.info_section)} >

                        <div id="label" className={css(styles.info_section_label)} >
                            {`Expenditures from ${this.state.data.startYear} to ${this.state.data.endYear}`}
                        </div>

                        <div id="value" className={css(styles.info_section_value)} >
                            {"$" + millify(+this.state.data.expenditures)}
                        </div>  
                        </div> 
                </React.Fragment>
            )
        }else if(this.state.requestState === RequestState.LOADING){
            content = (
                <div>
                    Loading
                </div>  
            );
        }else if(this.state.requestState === RequestState.ERROR){
            content = (
                <div>
                    {this.state.error}
                </div>
            );
        }else{

        }

        return (
            <div id="info_container" className={css(styles.card,styles.info_container)} >
                {content}
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/CombinedInfo.tsx